import gql from "graphql-tag";

export default gql`
  mutation addCreditHealthRating($friendly_entity_id: String!, $health_rating: String!, $user: String!) {
    addCreditHealthRating(friendly_entity_id: $friendly_entity_id, health_rating: $health_rating, user: $user) {
      __typename
      id
      friendly_entity_id
      health_rating
      current
      user
      created_time
      modified_time
    }
  }
`;
